import { useState } from 'react'

import TextInput from 'components/TextInput'

import { STRING } from 'resources'

import { SectionTitle } from './styles'

const InputsSection = () => {
  const [value1, setValue1] = useState('')
  const [value2, setValue2] = useState('')
  const [value3, setValue3] = useState('')
  const [value4, setValue4] = useState('')
  const [value5, setValue5] = useState('')
  const [value6, setValue6] = useState('')

  const updateValue = (setter) => (event) => {
    setter(event.target.value)
  }

  return (
    <>
      <SectionTitle>{STRING.designSystemScreen.inputs}</SectionTitle>
      <TextInput placeholder="Base Input" value={value1} onChange={updateValue(setValue1)} />
      <TextInput
        placeholder="Error Input"
        value={value2}
        onChange={updateValue(setValue2)}
        errorMessage="Error messaging"
        invalid
      />
      <TextInput placeholder="Disabled Input" value={value3} onChange={updateValue(setValue3)} disabled />
      <TextInput
        placeholder="Input with killi icon"
        iconName="cooking"
        value={value4}
        onChange={updateValue(setValue4)}
      />
      <TextInput label="Labelled Input" value={value5} onChange={updateValue(setValue5)} />
      <TextInput
        label="Labelled Input with killi icon"
        iconName="cooking"
        value={value6}
        onChange={updateValue(setValue6)}
      />
    </>
  )
}

export default InputsSection
